import makeStyles from "@mui/styles/makeStyles";

export const useDividerStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.grey[200],
  },
}));
